/**
 * 获取 url query
 */
export const getLocationQuery = () => {
  // 带哈希的路由 search 是''
  // let url = window.location.search // 获取url中"?"符后的字串
  let url = window.location.href.split('?')[1] || ''
  let theRequest = {}
  if (url.indexOf('=') !== -1) {
    let str = url
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

/**
 * 防抖：如果一个函数持续地触发，那么只在它结束后过一段时间只执行一次
 * @param {Function} fn 执行函数
 * @param {Number} delay 延迟的时间段(ms)
 */
export const debounce = function (fn, delay = 100) {
  let timer

  return function () {
    let context = this
    let args = arguments

    clearTimeout(timer)

    timer = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}

/**
 * 节流：如果一个函数持续的，频繁地触发，那么让它在一定的时间间隔后再触发。
 * @param {Function} fn 执行的函数
 * @param {Number} threshhold 多久执行一次的时间单位(ms)
 */
export const throttle = function (fn, threshhold = 250) {
  let last
  let timer

  return function () {
    let context = this
    let args = arguments

    let now = Date.now()

    if (last && now < last + threshhold) {
      clearTimeout(timer)

      timer = setTimeout(() => {
        last = now
        fn.apply(context, args)
      }, threshhold)
    } else {
      last = now
      fn.apply(context, args)
    }
  }
}

/**
 * 给页面动态设置标题
 * @param {String} title 页面标题
 */
export const setPageTitle = function (title) {
  document.title = title
}

/**
 * 转换精度为分数字为金额类型
 * @param {Number} mount 金额
 */
export const formatMoney = function (mount) {
  mount = mount / 100
  mount = mount.toFixed(2).toLocaleString()
  return mount
}

/**
 * 把毫秒数转换成 'n天-n小时-n分-n秒' 的对象
 * @param {Number} millisecond 毫秒数
 */
export const patchFormatMillisecond = (millisecond = 0) => {
  let dateClock = { days: 0, hours: 0, minutes: 0, seconds: 0, level: 0 }
  let tempRemainderSecond = millisecond // 求余所得
  let level = 0
  const secondMillisecond = 1000 // 一秒
  const minuteMillisecond = 60 * secondMillisecond // 一分钟
  const hourMillisecond = 60 * minuteMillisecond // 一小时
  const dayMillisecond = 24 * hourMillisecond // 一天
  if (tempRemainderSecond && tempRemainderSecond >= 0) {
    // 格式转换
    // 天数
    dateClock.days = Math.floor(tempRemainderSecond / dayMillisecond)
    tempRemainderSecond = tempRemainderSecond % dayMillisecond
    // 小时数
    dateClock.hours = Math.floor(tempRemainderSecond / hourMillisecond)
    tempRemainderSecond = tempRemainderSecond % hourMillisecond
    // 分钟数
    dateClock.minutes = Math.floor(tempRemainderSecond / minuteMillisecond)
    tempRemainderSecond = tempRemainderSecond % minuteMillisecond
    // 秒数
    dateClock.seconds = Math.floor(tempRemainderSecond / secondMillisecond)
    // 单位层级
    if (millisecond >= dayMillisecond) level = 4
    else if (millisecond >= hourMillisecond) level = 3
    else if (millisecond >= minuteMillisecond) level = 2
    else if (millisecond >= secondMillisecond) level = 1
    else { level = 0 }
    dateClock.level = level
  }
  return dateClock
}
